import { createAction, props } from "@ngrx/store";

import { BusinessClassificationState } from "../models/business-classification-state";
import { FailState } from "../models/fail-state";

export class BusinessClassificationActions {
	static readonly requested = createAction("[Business Classifications] Requested");
	static readonly apiRequested = createAction("[Business Classifications] Api Requested");
	static readonly loaded = createAction(
		"[Business Classifications] Loaded",
		props<BusinessClassificationState>()
	);
	static readonly failed = createAction(
		"[Business Classifications] Request Failed",
		props<FailState>()
	);
}
